import type { BenchmarkMatrixSelection, MatrixCatalog, MatrixRequest } from './types';

export const emptySelection: BenchmarkMatrixSelection = {
  setupId: '',
  measureIds: [],
  period: '',
  coverage: '',
  levelKeys: [],
  dimension: '',
  dimensionValue: '',
  pairs: {},
};

// Canonical values accepted by the comparison API, not customer-schema field IDs.
export const dimensionValues: Record<string, string[]> = {
  age_group: ['16-25', '26-35', '36-45', '46-55', '56-65', '65+'],
  gender: ['man', 'woman'],
  tenure: ['1y', '1-2y', '2-5y', '5-10y', '5-20y', '20y+'],
  manager: ['yes', 'no'],
};

export function matchingPairs(catalog: MatrixCatalog, selection: BenchmarkMatrixSelection) {
  return catalog.pairs.filter((pair) => pair.period === selection.period && pair.coverage === selection.coverage);
}

export function resolveRows(catalogs: MatrixCatalog[], selection: BenchmarkMatrixSelection): MatrixRequest[] {
  if (
    !selection.period ||
    !selection.coverage ||
    !selection.levelKeys.length ||
    (selection.dimension && !selection.dimensionValue)
  )
    return [];
  return catalogs.flatMap((catalog) => {
    if (!selection.measureIds.includes(catalog.measureId)) return [];
    const pairs = matchingPairs(catalog, selection);
    const pair = pairs.length === 1 ? pairs[0] : pairs.find((item) => item.id === selection.pairs[catalog.measureId]);
    if (!pair) return [];
    const levelKeys = selection.levelKeys.filter((key) => pair.levelKeys.includes(key));
    return levelKeys.length
      ? [{ measureId: catalog.measureId, internalId: pair.internalId, externalId: pair.externalId, levelKeys }]
      : [];
  });
}
